import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Agent from './Agent'
import styles from './styles.scss'

class Contact extends Component {
  _renderAgents = () => {
    const { agents, campaign } = this.props

    if (campaign.agents){
      return campaign.agents.map((agentId) => {
        const agent = agents[agentId] || {}
        return <Agent key={agent.id} agent={agent} campaign={campaign} />
      })
    }

    return null
  }

  render(){
    return (
      <section className={styles.root}>
        <span className={styles.text}>We are ready to move forward when you are, contact us:</span>

        {this._renderAgents()}
      </section>
    )
  }
}

Contact.propTypes = {
  agents: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Contact
